<template>
  <div
    class="text-sm font-normal"
    :class="
      isSent
        ? 'text-[var(--p-primary-950)] dark:text-[var(--p-primary-50)]'
        : 'text-[var(--p-surface-900)] dark:text-[var(--p-surface-0)]'
    "
  >
    {{ text }}
  </div>
</template>

<script setup lang="ts">
interface Props {
  text: string
  isSent: boolean
}

defineProps<Props>()
</script>
